import type { NavMainItem } from '@/types/nav/main'

const NAV_MAIN: NavMainItem[] = [
    {
        // Dashboard 2.0
        label: `Dashboard`,
        route: `/dashboard`,
        isTithelyGivingEnabled: false
    },
    {
        // Dashboard 3.0
        label: `Dashboard`,
        route: `/account/tithely/sso?redirect=/`,
        isTithelyGivingEnabled: true
    },
    {
        label: `People`,
        route: `/people`,
        roles: [`people`]
    },
    {
        label: `Giving`,
        key: `giving`,
        route: `/payments`,
        roles: [`contributions`]
    },
    {
        label: `Tags`,
        route: `/r/tags`,
        roles: [`tags`],
        isPaid: true // Only paid organizations have access to tags
    },
    {
        label: `Events`,
        route: `/r/events`,
        roles: [`events_view`],
        isPaid: true // Only paid organizations have access to events
    },
    {
        label: `Forms`,
        route: `/forms`,
        roles: [`forms`],
        isPaid: true // Only paid organizations have access to forms
    },
    {
        label: `Follow Ups`,
        route: `/followups`,
        roles: [`followups`],
        isPaid: true // Only paid organizations have access to follow-ups
    },
    {
        // Groups - only paid orgs with `tithely` as customer_id (2.0 and above) see this
        // user must also have either `groups` or `groups_leader` permission
        label: `Groups`,
        route: `/groups`,
        hasTithelyCustomerId: true,
        roles: [`groups`, `groups_leader`],
        orRoles: true,
        isPaid: true
    },
    {
        label: 'MailChimp',
        route: `/extensions/mailchimp`,
        roles: ['extensions_mailchimp'],
        secondary: true
    },
    {
        label: `Planning Center Online`,
        route: `/extensions/pco`,
        roles: ['extensions_pco'],
        secondary: true
    },
    {
        label: `QuickBooks Desktop`,
        route: `/extensions/quickbooks`,
        roles: ['extensions_quickbooks'],
        secondary: true
    },
    {
        // Normal Sites 2.0
        label: `Sites`,
        route: `/account/tithely/sso?redirect=/sites`,
        roles: ['extensions_sites'],
        features: ['sites_integration'],
        isTithelyGivingEnabled: false,
        secondary: true
    },
    {
        // Normal Sites 3.0
        label: `Sites`,
        route: `/account/tithely/sso?redirect=/sites`,
        roles: ['marketplace'],
        features: ['sites_integration'],
        isTithelyGivingEnabled: true,
        secondary: true
    },
    {
        // Upsell Sites 2.0
        label: `Sites`,
        route: `/extensions?name=sites_integration`,
        roles: ['marketplace'],
        features: [`tithely-bundle`, `!sites_integration`],
        badge: `Upgrade`,
        isTithelyGivingEnabled: false,
        secondary: true
    },
    {
        // Sites Sales 3.0
        label: `Sites`,
        route: `/account/tithely/sso?redirect=/offer/websites`,
        roles: ['marketplace'],
        features: [`!sites_integration`],
        badge: `Upgrade`,
        isTithelyGivingEnabled: true,
        secondary: true
    },
    {
        // Normal Apps 2.0
        label: `Apps`,
        route: `/account/tithely/sso?redirect=/apps`,
        roles: ['extensions_church_apps'],
        features: ['church_apps_integration'],
        secondary: true,
        isTithelyGivingEnabled: false // Remove for Apps Phase 2
    },
    {
        // Normal Apps 3.0
        label: `Apps`,
        route: `/account/tithely/sso?redirect=/apps`,
        roles: ['extensions_church_apps'],
        features: ['church_apps_integration'],
        isTithelyGivingEnabled: true,
        secondary: true
    },
    {
        // Upsell Apps 2.0
        label: `Apps`,
        route: `/extensions?name=church_apps_integration`,
        roles: ['marketplace'],
        features: [`tithely-bundle`, `!church_apps_integration`],
        badge: `Upgrade`,
        secondary: true,
        isTithelyGivingEnabled: false // Remove for Apps Phase 2
    },
    {
        // Apps Sales 3.0
        label: `Apps`,
        route: `/account/tithely/sso?redirect=/offer/apps`,
        roles: ['marketplace'],
        features: [`!church_apps_integration`],
        badge: `Upgrade`,
        isTithelyGivingEnabled: true,
        secondary: true
    },
    {
        label: `Extensions`,
        icon: `extensions`,
        route: `/extensions`,
        roles: [`marketplace`],
        features: ['!hub:trinity-ui', `!hub:breeze-bundle`],
        secondary: true
    },
    {
        label: `My Profile`,
        route: `/people/view/{linked_person_id}`,
        roles: [`show_my_profile`]
    },
    {
        label: `Give Now`,
        route: `/give/internal`,
        roles: [`linked_people_give`],
        isTithelyGivingEnabled: false
    }
]

export default NAV_MAIN
